import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { shelfShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import FieldList from '../../shared/Facets/FieldList';

import './ShelfFacets.scss';

export class ShelfFacets extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleExpandField');
  }

  handleExpandField(fieldId) {
    const { owner, shelf, location } = this.props;
    this.props.shelfActions.fetchAdditionalFilters(shelf.get('name'), owner.get('id'), fieldId, location.query);
  }

  render() {
    const {
      activeFilters,
      shelf,
      drawerActions
    } = this.props;

    return (
      <div className="cp-shelf-facets">
        <FieldList
          fields={shelf.get('facets')}
          drawerActions={drawerActions}
          activeFilters={activeFilters}
          handleExpandField={this.handleExpandField} />
      </div>
    );
  }
}

ShelfFacets.propTypes = {
  activeFilters: ImmutablePropTypes.map.isRequired,
  owner: userIdentityShape.isRequired,
  shelf: shelfShape.isRequired,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default withRouter(ShelfFacets);



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfFacets/ShelfFacets.jsx